import { Clock } from 'lucide-react'

import { Button } from '@/components/ui/button'

interface CompleteRegistrationStandardProps {
  onContinue?: () => void
}

const CompleteRegistrationStandard = ({
  onContinue,
}: CompleteRegistrationStandardProps) => {
  const redirectText = import.meta.env.VITE_COMPLETE_REDIRECT_TEXT || 'Continue'
  const redirectUrl = import.meta.env.VITE_COMPLETE_REDIRECT_URL
  const customRedirect =
    import.meta.env.VITE_CUSTOM_COMPLETE_REDIRECT === 'true'

  const handleContinue = () => {
    if (customRedirect && redirectUrl) {
      window.location.href = redirectUrl
    } else if (onContinue) {
      onContinue()
    }
  }

  return (
    <div className="min-h-screen bg-transparent flex items-center justify-center p-4">
      <div className="w-full max-w-md mx-auto bg-white dark:bg-gray-900 rounded-lg shadow-xl overflow-hidden h-[600px] flex flex-col">
        <div className="p-6 flex-1 flex flex-col overflow-y-auto">
          <div className="text-center space-y-6 flex-1 flex flex-col justify-center">
            <div className="w-20 h-20 rounded-full bg-blue-100 dark:bg-blue-900 flex items-center justify-center mx-auto">
              <Clock className="w-10 h-10 text-blue-600 dark:text-blue-400" />
            </div>
            <div className="space-y-3">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
                Registration Complete
              </h2>
              <div className="space-y-2">
                <p className="text-gray-600 dark:text-gray-400">
                  Please allow up to 24 hours for us to verify your identity.
                </p>
                <p className="text-sm text-gray-500 dark:text-gray-500">
                  You'll receive an email notification once your account has
                  been approved and is ready to use.
                </p>
              </div>
            </div>

            <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-4 border border-blue-200 dark:border-blue-800">
              <h3 className="font-medium text-blue-900 dark:text-blue-100 mb-2">
                What happens next?
              </h3>
              <ul className="text-sm text-blue-700 dark:text-blue-300 space-y-1 text-left">
                <li>• We'll review your submitted documents</li>
                <li>• Identity verification typically takes 1-24 hours</li>
                <li>
                  • You'll receive email updates on your application status
                </li>
              </ul>
            </div>

            {(customRedirect && redirectUrl) || onContinue ? (
              <Button
                onClick={handleContinue}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white h-12 font-semibold"
              >
                {redirectText}
              </Button>
            ) : (
              <div className="text-sm text-gray-500 dark:text-gray-400">
                You can close this window safely.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CompleteRegistrationStandard
